import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  exports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    IonicModule,
  ],
})
export class SharedLibsModule {}
